export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Bold.29038274.woff";